<template>
	<div class="container mx-auto">
		<!-- Banner -->
		<AppBanner class="mb-5 sm:mb-8" />
		
		<section id="aboutme">
			<AboutMe/>
			<!-- <AboutService/> -->
			<AboutTectStack/>
		</section>

		<!-- Projects -->
		<section id="projects" class="mb-5">
			<ProjectsGrid />
			<!-- Load more projects button -->
			<!-- <div class="mt-10 sm:mt-20 flex justify-center">
				<router-link
					to="/projects"
					class="font-general-medium flex items-center px-6 py-3 rounded-lg shadow-lg hover:shadow-xl bg-indigo-500 hover:bg-indigo-600 focus:ring-1 focus:ring-indigo-900 text-white text-lg sm:text-xl duration-300"
					aria-label="More Projects"
				>
					<Button title="More Projects" />
				</router-link>
			</div> -->
		</section>

		<section id="contact">
			<div data-aos="fade-up" data-aos-duration="1200" class="text-center">
				<p class="font-general-semibold text-2xl mt-5 sm:mt-20 sm:text-4xl font-semibold  text-ternary-dark dark:text-ternary-light">
					CONTACT
				</p>
			</div>
			<div class="mx-auto flex flex-col-reverse md:flex-row py-5 md:py-10 md:mt-10">
				<ContactForm />
				<ContactDetails :contacts="contacts" />
			</div>
		</section>
		
	
		
	</div>
</template>
<script>
import AppBanner from '@/components/Layouts/AppBanner';
import ProjectsGrid from '../components/projects/ProjectsGrid.vue';
import AboutMe from '@/components/about/AboutMe';
import AboutTectStack from '@/components/about/AboutTectStack';
/* import AboutService from '@/components/about/AboutService'; */
import ContactForm from '@/components/contact/ContactForm.vue';
import ContactDetails from '@/components/contact/ContactDetails.vue';

export default {
	name: 'Home',
	components: {
		AppBanner,
		ProjectsGrid,
		AboutMe,
		AboutTectStack,
		/* AboutService, */
		ContactForm,
		ContactDetails
	},
	data() {
		return {
			contacts: [
				{
					id: 1,
					name: 'P-2 Libertad Echague, Isabela, Philippines',
					icon: 'map-pin',
				},
				{
					id: 2,
					name: 'magaoaywilson14@gmail.com',
					icon: 'mail',
				},
				{
					id: 3,
					name: '09852394030',
					icon: 'phone',
				},
			],
		}
	},
};
</script>
